// extracted by mini-css-extract-plugin
module.exports = {"cardGradient":"ProfileCard_cardGradient__PNecu","detailsContainer":"ProfileCard_detailsContainer__9LkrF"};